import React from "react";
import { Box, Typography } from "@mui/material";
import AppCardComponent from "../mui/AppCardComponent";

const CommonFeatureCard = ({
    label,
    subtitle,
    icon,
    iconCmp,
    badge,
    arrow,
    card = false, // FeatureBox vs Card Style
    onClick,
    backgroundColor,
    border,
    iconSize
}) => {

    const content = (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: (icon || iconCmp) ? "flex-start" : "center",
                gap: 2,
                width: "100%",
                boxSizing: "border-box",
                pr: arrow || badge ? 1 : 0
            }}
        >
            {(icon || iconCmp) && (
                <Box
                    sx={{
                        borderRadius: subtitle ? "8px" : "50%",
                        backgroundColor: subtitle ? "rgba(255,255,255,0.05)" : "transparent",
                        padding: subtitle ? "8px" : (iconSize ? "0px" : "12px"),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: subtitle ? "1px solid rgba(255,255,255,0.1)" : "none",
                    }}
                >
                    {icon ? (
                        <Box
                            component="img"
                            src={icon}
                        sx={{ 
                            width: iconSize || "32px", 
                            height: iconSize || "32px",
                            objectFit: "contain"
                        }}
                        />
                    ) : (
                        iconCmp
                    )}
                </Box>
            )}

            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: subtitle ? "0.85rem" : ((icon || iconCmp) ? "1.1rem" : "1rem"),
                        color: subtitle ? "rgba(255,255,255,0.6)" : "white"
                    }}
                >
                    {label}
                </Typography>
                {subtitle && (
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: "1rem",
                            color: "white"
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>

            {
                badge && (
                    <Box sx={{ ml: "auto", display: 'flex', alignItems: 'center' }}>
                        {badge}
                    </Box>
                )
            }

            {
                arrow && (
                    <Box sx={{ ml: badge ? 2 : "auto", display: "flex", alignItems: "center", color: 'rgba(255,255,255,0.5)' }}>
                        {arrow}
                    </Box>
                )
            }
        </Box >
    );

    // FeatureBox Style
    if (!card) {
        return (
            <Box
                onClick={onClick}
                sx={{
                    backgroundColor: backgroundColor || "#25293b",
                    borderRadius: "8px",
                    padding: "16px 24px",
                    textAlign: "center",
                    width: { xs: "100%", md: "380px" },
                    minHeight: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    border: border || "1px solid rgba(255,255,255,0.1)",
                    cursor: onClick ? "pointer" : "default"
                }}
            >
                {content}
            </Box>
        );
    }

    // Security Card Style
    return (
        <AppCardComponent
            onClick={onClick}
            sx={{
                backgroundColor: backgroundColor || "#25293b",
                color: "white",
                borderRadius: "12px",
                border: border || "1px solid rgba(255,255,255,0.1)",
                minHeight: "100px",
                display: "flex",
                alignItems: "center",
                cursor: onClick ? "pointer" : "default",
                "& .MuiCardContent-root": {
                    width: "100%",
                    padding: "16px 24px",
                    "&:last-child": {
                        paddingBottom: "16px",
                    }
                }
            }}
        >
            {content}
        </AppCardComponent>
    );
};

export default CommonFeatureCard;